import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Box, Typography, Button, Stack } from "@mui/material";
import { C, NAV } from "./constants";
import SvgIcon from "../ipd-billing/SvgIcon";

const SIDEBAR_W = 240;

function Sidebar({ activeNav, onNav, facilityName }) {
  return (
    <Box
      component="aside"
      sx={{
        position: "sticky",
        top: 0,
        left: 0,
        width: SIDEBAR_W,
        flexShrink: 0,
        minHeight: "calc(100vh - 140px)",
        alignSelf: "stretch",
        overflowY: "auto",
        bgcolor: C.sidebarBg,
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        p: "20px 12px",
        borderRight: "1px solid #1e3a5f",
        boxSizing: "border-box",
        zIndex: 100,
      }}
    >
      <Stack
        direction="row"
        spacing={1.25}
        sx={{
          alignItems: "center",
          px: 1,
          pb: 1.75,
          mb: 0.5,
          borderBottom: "1px solid #1e3a5f",
          flexShrink: 0,
        }}
      >
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: "8px",
            bgcolor: "#1a4a7a",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <SvgIcon name="pill" size={17} color="#fff" />
        </Box>
        <Box>
          <Typography sx={{ fontSize: 15, fontWeight: 800, color: "#fff", lineHeight: 1.2 }}>
            HTMATE
          </Typography>
          <Typography sx={{ fontSize: 10, fontWeight: 600, color: "#7eb3d8", letterSpacing: "0.05em" }}>
            OPERATION THEATRE · HMIS
          </Typography>
        </Box>
      </Stack>

      <Box sx={{ px: 1.25, py: 1, pb: 1.5, borderBottom: "1px solid #1e3a5f", mb: 1, flexShrink: 0 }}>
        <Typography sx={{ fontSize: 9, fontWeight: 700, color: "#4a7a9b", textTransform: "uppercase", letterSpacing: "0.08em", mb: 0.5 }}>
          Facility
        </Typography>
        <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#c7dff0" }}>
          {facilityName}
        </Typography>
      </Box>

      <Typography sx={{ fontSize: 9, fontWeight: 700, color: "#4a7a9b", textTransform: "uppercase", letterSpacing: "0.08em", px: 1, mb: 0.75, flexShrink: 0 }}>
        Workspace
      </Typography>

      <Stack component="nav" spacing={0.25} sx={{ flexShrink: 0 }}>
        {NAV.map((item) => {
          const active = activeNav === item.id;
          const noRoute = !item.route;
          return (
            <Button
              key={item.id}
              onClick={() => onNav(item)}
              disabled={noRoute}
              title={noRoute ? "Coming soon" : item.label}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: 1.25,
                px: 1.5,
                py: 1.125,
                borderRadius: "7px",
                width: "100%",
                minWidth: 0,
                bgcolor: active ? C.sidebarActive : "transparent",
                color: active ? "#fff" : noRoute ? "#3d5e78" : "#a8c4d8",
                fontSize: 13,
                fontWeight: 600,
                textTransform: "none",
                opacity: noRoute ? 0.6 : 1,
                "&:hover": {
                  bgcolor: active ? C.sidebarActive : noRoute ? "transparent" : C.sidebarHover,
                },
              }}
            >
              <SvgIcon
                name={item.icon}
                size={16}
                color={active ? "#fff" : noRoute ? "#3d5e78" : "#7eb3d8"}
              />
              {item.label}
            </Button>
          );
        })}
      </Stack>

      <Box
        sx={{
          mt: "auto",
          mx: "3px",
          mb: "3px",
          borderRadius: "10px",
          bgcolor: "#071828",
          border: "1px solid #1e3a5f",
          p: "12px 14px",
          flexShrink: 0,
        }}
      >
        <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#c7dff0" }}>
          On-call surgeon
        </Typography>
        <Typography sx={{ mt: 0.5, fontSize: 11, color: "#7eb3d8" }}>
          Dr. A. Mehra · Ext 4421
        </Typography>
      </Box>
    </Box>
  );
}

export default function OTLayout({ activeNav, children }) {
  const history = useHistory();
  const facilityName =
    sessionStorage.getItem("facility_display_name") ||
    sessionStorage.getItem("facility_name") ||
    "Your Facility";

  useEffect(() => {
    if (!sessionStorage.getItem("accessToken")) history.push("/login");
  }, [history]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [activeNav]);

  const handleNav = (item) => {
    if (item.route) history.push(item.route);
  };

  return (
    <Box sx={{ display: "flex", alignItems: "stretch" }}>
      <Sidebar activeNav={activeNav} onNav={handleNav} facilityName={facilityName} />
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          bgcolor: C.bg,
          minHeight: "calc(100vh - 140px)",
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
